import templateUrl from './rogers-report-history.component.html';
import { JobStatus } from '../../../../core/enum/job-status';
import { ReportJobVM } from '../../../../core/services';
import { EventEmitter } from '../../../../common/components/event-emitter';

export const RogersReportHistoryComponent = {
    bindings: {
        jobs: "<",
        caption: "@",
        viewDetails: "&onViewDetails",
        cancel: "&onCancel"
    },
    templateUrl,
    controller: class RogersReportHistoryController {
        caption: string;
        jobs: ReportJobVM[];
        JobStatus = JobStatus;
        pageNumber = 1;
        pageSize = 6;
        viewDetails: EventEmitter<{ job: ReportJobVM }>;
        cancel: EventEmitter<{ job: ReportJobVM }>;
        constructor() {
            'ngInject';
        }

        $onInit() {
            this.caption = this.caption || "Rogers Report History";
        }

        onViewDetails(job) {
            this.viewDetails({
                $event: {
                    job: job
                }
            });
        }

        onCancel(job) {
            //this.cancel({
            //    $event: {
            //        job: job
            //    }
            //});
        }
    }
}
